 import { Environment } from '@abp/ng.core';

const baseUrl = 'https://chemicalequipmentcalibration-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://chemicalequipmentcalibration-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'ChemicalEquipmentCalibration_App',
  responseType: 'code',
  scope: 'offline_access ChemicalEquipmentCalibration',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'ChemicalEquipmentCalibration',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://chemicalequipmentcalibration-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.ChemicalEquipmentCalibration',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '1.0.0',
} as Environment;
